const en = {
  generics: {},
  auth: {},
};
export default en;
